module.exports = __webpack_public_path__ + "static/img/ad2-1.fefda3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad2-1.png
// module id = erWF
// module chunks = 12